export default "<app-admin>\n  <div fxLayout=\"column\" fxLayoutAlign=\"center center\">\n    <h2>Welcome to admin setup</h2>\n  </div>\n</app-admin>"